import React from 'react';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import BasicFormField from '../../../common/formFields/basicFormField';

const Passcode = () => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-p0 u-mb-">
      Booking Code
    </div>
    <div className="u-ph">
      <div className="layout">
        <CheckboxSwitch
          name="requirePasscode"
          id="requirePasscode"
          label="Require booking code on web booking?"
          wrapperClass="layout__item"
        />
        <BasicFormField label="Booking Code" name="passcode" />
      </div>
    </div>
  </div>
);

export default Passcode;
